module.exports = __webpack_public_path__ + "../resources/img/ic_cellular_on.4bc9bc01.svg";